import React from 'react'
import Logo from './Logo'
import {Typography} from '@mui/material'

export const ETError = ({mensaje})=>{
    return  <div className="flex items-center justify-center h-screen px-4">
          <div className="flex flex-col items-center text-center max-w-[400px] w-full">
            <Logo/>
            <Typography
              sx={{ color: "firebrick", fontWeight: 500 }}
              variant="h6"
            >
              {mensaje ? mensaje :
              `No es posible acceder al servicio de eventos en este momento.
              Por favor intente más tarde nuevamente.`
              }
            </Typography>
          </div>
        </div>
}

